import React from 'react';
import { EventsView } from './EventsView';

export const EventsScreen = (
): React.ReactElement => {

    return <EventsView />
}